const facilityFormsPath = '/facilities/questions-forms';
export const getfacilityForms = facilityFormsPath;
export const getFacilityFormById = (id: number) => `${facilityFormsPath}/${id}`;
export const createFacilityForm = facilityFormsPath;
export const updateFacilityForm = (id: number) => `${facilityFormsPath}/${id}`;
export const getUserFormResponse = (id: number) => `${facilityFormsPath}/responses/${id}`;